import script from "./Savings.vue?vue&type=script&setup=true&lang=js"
export * from "./Savings.vue?vue&type=script&setup=true&lang=js"

import "./Savings.vue?vue&type=style&index=0&id=4d35d137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d35d137"]])

export default __exports__